import { NewFieldLabel, NewFieldStyleOverrides, TextField } from "~components";
import { Css } from "~generated/css";
import { ErrorMessage } from "./ErrorMessage";

type EmailTextFieldProps = {
  value: string;
  onChange: (email: string) => void;
  onEnter?: () => void;
  disabled?: boolean;
  error?: string | null;
};

export function EmailTextField({ value, onChange, onEnter, disabled, error }: EmailTextFieldProps) {
  return (
    <div css={Css.w100.$}>
      <TextField
        cssOverrides={NewFieldStyleOverrides}
        label={NewFieldLabel("Email*")}
        type="email"
        placeholder="Email"
        value={value}
        onChange={(_, email) => onChange(email)}
        onKeyDown={(_, key) => {
          if (key === "Enter" && onEnter) {
            onEnter();
          }
        }}
        autoComplete="email"
        required
        disabled={disabled}
      />
      {error && <ErrorMessage message={error} />}
    </div>
  );
}
